// extracted by mini-css-extract-plugin
export default {"root":"ChartExplorerPageBody_root__1Os3W"};